// src/components/Sidebar/SidebarTopics.tsx
"use client";
import { ChevronDown } from "lucide-react";

import { useRecordContext } from "@/contexts/RecordContext";
import { TopicManager } from "../TopicManager";

type SidebarTopicsProps = {
  openSection: string | null;
  setOpenSection: (section: string | null) => void;
  disabled?: boolean;
};

export default function SidebarTopics({ openSection, setOpenSection, disabled }: SidebarTopicsProps) {
  const recordContext = useRecordContext();
  if (!recordContext) {
    return <div style={{ color: 'red' }}>Context未提供です</div>;
  }

  const { selectedTopic, setSelectedTopic } = recordContext;

  const isOpen = openSection === "topics";

  const handleToggle = () => {
    if (!disabled) setOpenSection(isOpen ? null : "topics");
  };

  return (
    <nav className={`border-t pt-4 mt-6 ${disabled ? "opacity-50 pointer-events-none select-none" : ""}`}>
      <h2
        className={`text-sm font-bold mb-2 cursor-pointer flex justify-between items-center 
          ${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-700"}
        `}
        onClick={handleToggle}
      >
        お題リスト
        <ChevronDown size={14} className={isOpen ? "rotate-180 transition-transform" : "transition-transform"} />
      </h2>

      {isOpen && (
        <>
          {/* ▼ TopicManager が内部でタブを持つので、SidebarTopics には不要 */}
          <TopicManager
            selectedTopic={selectedTopic as any}
            setSelectedTopic={setSelectedTopic}
          />

          {/* ▼ 有料ガード（必要なら残す） */}
          {disabled && (
            <div className="mt-2 px-3 py-1 bg-yellow-100 text-yellow-800 rounded text-xs font-bold">
              この機能は有料プランでご利用いただけます
            </div>
          )}
        </>
      )}
    </nav>
  );
}
